import gql from 'graphql-tag';

const CreateOnetimePasswordMutation = gql`
  mutation CreateOnetimePassword($input: UserOnetimePasswordInput!) {
    user_onetime_password(input: $input)
  } 
`;

export const createOnetimePasswordApi = async (client, phoneNumber) => {
  const variables = {
    input: {
      phone_number: phoneNumber,
    },
  };

  const options = {
    mutation: CreateOnetimePasswordMutation,
    variables,
  };
  const result = await client.mutate(options);
  return result;
};
